module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_iterators.js
// module id = ../../../../core-js/library/modules/_iterators.js
// module chunks = 3